import axios from "axios";
import { ELEMENT_NAME } from "../../Constants/app.constant";
import { getUrlQuery } from "../../Utils/getUrlQuery";
import debounceAsync from "../../Utils/debounceAsync";

const service = axios.create({
  baseURL: process.env.REACT_APP_SESSION_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-liquid-product': 'elements',
    'x-liquid-type': ELEMENT_NAME,
    'Authorization': getUrlQuery().get('token')
  }
})

async function saveApiSession({ id, payload }) {
  const { data } = await service.post('/', { id, payload: payload && JSON.parse(payload) });
  return { id: data.id, payload: JSON.stringify(data.payload) };
}

const debounceSaveSession = debounceAsync(saveApiSession, 100);
let initialized = false;

export default async function saveSession({ id, payload }) {
  if (!initialized) {
    initialized = true;
    return await saveApiSession({ id, payload });
  }

  return await debounceSaveSession({ id, payload });
}
